import {URL_WEB_SERVICE_LOCAL_STORAGE} from './general'

export const GET_FILTROS = `${URL_WEB_SERVICE_LOCAL_STORAGE}getFiltros`;

export const GET_CPLANES_FAMILIA = `${URL_WEB_SERVICE_LOCAL_STORAGE}getCPlanesXFamilia`;

export const GET_CPLANES_SERVICIO = `${URL_WEB_SERVICE_LOCAL_STORAGE}getCPlanesXServicio`;

export const GET_CPLANES_CATEGORIA = `${URL_WEB_SERVICE_LOCAL_STORAGE}getCPlanesXCategoria`;

export const GET_CATEGORIES = `${URL_WEB_SERVICE_LOCAL_STORAGE}getCategorias`;

export const GET_CHANNELS = `${URL_WEB_SERVICE_LOCAL_STORAGE}getCanales`;